<template>
  <div class="legal-info">
    <div class="legal-cards">
      <div class="legal-card">
        <div class="legal-icon">📋</div>
        <h3>服务条款</h3>
        <p>了解我们的服务条款和使用规则，包括TikTok API集成的相关规定。</p>
        <router-link to="/terms-of-service" class="legal-link">查看详情</router-link>
      </div>
      
      <div class="legal-card">
        <div class="legal-icon">🔒</div>
        <h3>隐私政策</h3>
        <p>了解我们如何收集、使用和保护您的个人信息，包括TikTok数据的安全措施。</p>
        <router-link to="/privacy-policy" class="legal-link">查看详情</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalInfo'
}
</script>

<style scoped>
.legal-info {
  margin: 2rem 0;
  padding: 0 1rem;
}

.legal-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
}

.legal-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.legal-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.legal-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.legal-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.legal-card p {
  line-height: 1.6;
  margin-bottom: 1.5rem;
  opacity: 0.9;
}

.legal-link {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: background-color 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.legal-link:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .legal-cards {
    grid-template-columns: 1fr;
  }
  
  .legal-card {
    padding: 1.5rem;
  }
  
  .legal-icon {
    font-size: 2.5rem;
  }
}
</style> 